'use client';

import { Button, Card, CardBody } from '@nextui-org/react';
import { Gift, Sparkles } from 'lucide-react';

import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';

export const HomeReviewPromoCta = () => {
  return (
    <section
      className="w-full min-w-0 max-w-full overflow-x-clip py-6 md:py-8"
      aria-labelledby="home-review-promo-heading"
    >
      <Card className="min-w-0 w-full max-w-full overflow-hidden border border-default-200/80 bg-gradient-to-br from-warning/15 via-content1 to-amber-50/40 shadow-lg ring-1 ring-warning/10 dark:from-warning/10 dark:via-default-100/30 dark:to-default-100/10 dark:ring-warning/5">
        <CardBody className="relative flex min-h-0 min-w-0 flex-col gap-6 overflow-hidden p-6 md:flex-row md:items-center md:gap-10 md:p-8 lg:p-10">
          {/* Блюры только внутри inset — не раздувают страницу и не дают скролл */}
          <div
            className="pointer-events-none absolute inset-0 overflow-hidden rounded-2xl"
            aria-hidden
          >
            <div className="absolute -right-8 -top-8 h-36 w-36 rounded-full bg-warning/15 blur-3xl dark:bg-warning/5" />
            <div className="absolute -bottom-6 -left-6 h-32 w-32 rounded-full bg-amber-200/25 blur-2xl dark:bg-amber-500/10" />
          </div>

          <div className="relative z-[1] flex shrink-0 items-center justify-center md:self-start">
            <span className="flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-warning to-amber-500 text-white shadow-lg shadow-warning/25 ring-2 ring-warning/20 ring-offset-2 ring-offset-transparent md:h-24 md:w-24">
              <Gift className="h-10 w-10 md:h-11 md:w-11" aria-hidden />
            </span>
          </div>

          <div className="relative z-[1] min-w-0 flex-1 text-center md:text-left">
            <div className="mb-2 inline-flex max-w-full items-center gap-1.5 rounded-full bg-warning/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-warning-800 dark:text-warning-400">
              <Sparkles className="h-3.5 w-3.5 shrink-0" aria-hidden />
              Бонус за отзыв
            </div>
            <h2
              id="home-review-promo-heading"
              className="break-words text-2xl font-bold tracking-tight text-foreground md:text-3xl"
            >
              Оставь отзыв — получи скидку 10%
            </h2>
            <p className="mt-2 max-w-full text-sm leading-relaxed text-default-600 break-words md:max-w-xl md:text-base">
              Расскажи о мастер-классе, который покупал. После проверки модератором
              отзыв появится на сайте, а на твой email придёт промокод на{' '}
              <span className="font-semibold text-foreground">10% скидки</span> на
              следующую покупку.
            </p>
            <div className="mt-5 flex min-w-0 flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center md:justify-start">
              <Button
                as={Link}
                href={ROUTES.masterclasses}
                color="warning"
                className="min-w-0 max-w-full shrink font-semibold"
                size="lg"
                radius="full"
              >
                Выбрать мастер-класс
              </Button>
              <Link
                href={ROUTES['reviews-rules']}
                className="min-w-0 max-w-full shrink text-center text-sm font-medium text-default-600 underline-offset-2 hover:text-foreground hover:underline sm:text-left"
              >
                Правила публикации отзывов
              </Link>
            </div>
          </div>
        </CardBody>
      </Card>
    </section>
  );
};
